<template>
  <div class="finance_box" ref="myElementRef">
    <div ref="searchBox" v-if="state.flng">
      <hc-search :data="serchData" @serch="getSarch($event)" @getadd="getadd($event)" />
    </div>
    <!-- 表格 -->
    <div class="table_box">
      <hc-table 
        :tableData="tableData" 
        :column="state.tableHeader" 
        :offsetHeight="state.offsetHeight"
        :maxPage="maxPage"
        @pageChange="pageChange($event)"
        @limitChange="limitChange($event)"
      >
        <template #status="{ row }">
          <el-tag :type="row.status == 1 ? 'success' : 'danger'">
            {{ row.status == 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
        <template #alarm_level="{ row }">
          <el-tag :type="getLevelTagType(row.alarm_level)">
            {{ getLevelLabel(row.alarm_level) }}
          </el-tag>
        </template>
        <template #operation="scope">
          <div class="btn_box_det">
            <el-button size="small" type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" link @click="del(scope.row)">删除</el-button>
          </div>
        </template>
      </hc-table>
    </div>
    
    <el-dialog align-center v-model="dialogVisible" title="设备告警分类信息" width="550" draggable>
      <div class="userAdd_man">
        <el-form label-width="auto" :model="formLabelAlign" class="userFrom" ref="formRef" :rules="rules">
          <el-form-item label="告警编码" prop="alarm_code">
            <el-input v-model="formLabelAlign.alarm_code" placeholder="请输入告警编码" :disabled="formLabelAlign.id > 0" />
          </el-form-item>
          <el-form-item label="告警名称" prop="alarm_name">
            <el-input v-model="formLabelAlign.alarm_name" placeholder="请输入告警名称" />
          </el-form-item>
          <el-form-item label="告警级别" prop="alarm_level">
            <el-select v-model="formLabelAlign.alarm_level" placeholder="请选择告警级别" style="width: 100%;">
              <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="告警字节" prop="alarm_byte">
            <el-input v-model="formLabelAlign.alarm_byte" placeholder="请输入告警字节字段" />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="formLabelAlign.status" placeholder="请选择状态" style="width: 100%;">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="3" v-model="formLabelAlign.remark" placeholder="请输入备注" />
          </el-form-item>
        </el-form>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="subimt($refs.formRef)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { 
  DeviceAlarmTypeAdd, 
  DeviceAlarmTypeList, 
  DeviceAlarmTypeDel 
} from '@/api/deviceAlarmType.js';
import { DictDataByCode } from '@/api/dictionary.js';

const myElementRef = ref();
const searchBox = ref();
let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const dialogVisible = ref(false);

const rules = reactive({
  alarm_code: [
    { required: true, message: "告警编码不能为空", trigger: "blur" },
  ],
  alarm_name: [
    { required: true, message: "告警名称不能为空", trigger: "blur" },
  ],
  alarm_level: [
    { required: true, message: "请选择告警级别", trigger: "change" },
  ],
  status: [
    { required: true, message: "请选择状态", trigger: "change" },
  ],
});

const statusOptions = [
  { label: "禁用", value: 0 },
  { label: "启用", value: 1 },
];

const levelOptions = ref([]);

const tableData = ref([]);

const serchData = reactive([
  {
    label: "告警名称",
    type: "input",
    value: "",
  },
  {
    label: "",
    type: "add",
    value: true
  }
]);

const state = reactive({
  title: "",
  column: [
    {
      type: "index",
      show: true,
      label: "序号",
      width: 80,
    },
    {
      prop: "alarm_code",
      show: true,
      label: "告警编码",
      width: 150,
    },
    {
      prop: "alarm_name",
      show: true,
      label: "告警名称",
      width: 400,
    },
    {
      prop: "alarm_level",
      show: true,
      label: "告警级别",
      width: 150,
    },
    {
      prop: "alarm_byte",
      show: true,
      label: "告警字节",
      width: 150,
    },
    {
      prop: "status",
      show: true,
      label: "状态",
      width: 120,
    },
    {
      prop: "remark",
      show: true,
      label: "备注",
      width: 200,
    },
    {
      prop: "created_at",
      show: true,
      label: "创建时间",
      width: 200,
    },
    {
      prop: "operation",
      show: true,
      label: "操作",
      width: 140, 
    },
  ],
  flng: true,
  offsetHeight: 0,
  tableHeader: [],
});

const formLabelAlign = reactive({
  id: 0,
  alarm_code: "",
  alarm_name: "",
  alarm_level: "",
  alarm_byte: "",
  status: 1,
  remark: ""
});

const getLevelTagType = (level) => {
  switch (String(level)) {
    case "1": return "danger"; // 严重警告
    case "2": return "warning"; // 一般警告
    case "3": return "info"; // 提示警告
    default: return "";
  }
};

const getLevelLabel = (level) => {
  const option = levelOptions.value.find(item => String(item.value) === String(level));
  return option ? option.label : level;
};

// 动态改变表头
const change = (item) => {
  tableHeaderFn();
};

onMounted(() => {
  try {
    nextTick(() => {
      offHeighths();
    });
    window.onresize = () => {
      nextTick(() => {
        offHeighths();
      });
    };
    tableHeaderFn();
  } catch { }
  getList();
  loadLevelOptions();
});

const loadLevelOptions = async () => {
  try {
    const res = await DictDataByCode('alarmLevel');
    if (res.code === 200 && res.data) {
      levelOptions.value = res.data.map(item => ({
        label: item.dict_label,
        value: item.dict_value
      }));
    }
  } catch (e) {
    console.error("加载告警级别数据字典失败", e);
  }
};

const offHeighths = () => {
  if (myElementRef.value) {
    state.offsetHeight =
      myElementRef.value?.offsetHeight - 130 - searchBox.value?.offsetHeight;
  }
};

onUnmounted(() => {
  window.onresize = null;
});

const getadd = () => {
  Object.assign(formLabelAlign, {
    id: 0,
    alarm_code: "",
    alarm_name: "",
    alarm_level: "",
    alarm_byte: "",
    status: 1,
    remark: ""
  });
  dialogVisible.value = true;
};

const edit = async (row) => {
  Object.assign(formLabelAlign, {
    id: row.id,
    alarm_code: row.alarm_code,
    alarm_name: row.alarm_name,
    alarm_level: row.alarm_level,
    alarm_byte: row.alarm_byte,
    status: row.status,
    remark: row.remark
  });
  dialogVisible.value = true;
};

// 查询
const getSarch = (data) => {
  page.value = 1;
  getList();
};

const pageChange = (currentPage) => {
  page.value = currentPage;
  getList();
};

const limitChange = (currentLimit) => {
  page.value = 1;
  limit.value = currentLimit;
  getList();
};

// 表头筛选
const tableHeaderFn = () => {
  state.tableHeader = state.column.filter((v) => {
    if (v.show) {
      return v.show == true;
    } else {
      v.show = false;
    }
  });
};

const getList = async () => {
  const res = await DeviceAlarmTypeList({
    current: page.value,
    size: limit.value,
    alarmName: serchData[0].value
  });
  if (res.code === 200 && res.data) {
    tableData.value = res.data.records || [];
    maxPage.value = res.data.total || 0;
  } else {
    tableData.value = [];
    maxPage.value = 0;
  }
};

const subimt = async (formEl) => {
  if (!formEl) return;

  await formEl.validate(async (valid) => {
    if (valid) {
      try {
        const data = { ...formLabelAlign };
        const res = await DeviceAlarmTypeAdd(data);
        if (res.code === 200) {
          dialogVisible.value = false;
          ElMessage.success('保存成功');
          getList();
        } else {
          ElMessage.error(res.msg || '保存失败');
        }
      } catch (error) {
        ElMessage.error('保存失败，请重试');
      }
    } else {
      ElMessage.warning('请填写完整的信息');
    }
  });
};

const del = (row) => {
  ElMessageBox.confirm('确认要删除该设备告警分类信息吗？', '删除提醒', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    getDel(row);
  }).catch(() => {});
};

const getDel = async (row) => {
  const res = await DeviceAlarmTypeDel({
    id: row.id
  });
  if (res.code === 200) {
    ElMessage.success('删除成功');
    getList();
  } else {
    ElMessage.error(res.msg || '删除失败');
  }
};
</script>

<style lang="less" scoped>
.finance_box {
  flex: 1;
  overflow: auto;
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  margin-right: 10px;
}

.btn_box {
  height: 40px;
  display: flex;
}

.table_box {
  width: 100%;
  /deep/ .el-image {
    cursor: pointer;
  }
}

/deep/.el-button-group .el-button--primary:first-child {
  background-color: #1e6aed;
  border: none;
}

.serBtn {
  margin-left: 10px;
  background-color: #f0f0f0;
  color: #000;
  border: none;
}

.serBtn:hover {
  background-color: #f0f0f0;
  color: #000;
}

.opBtn {
  margin: 0 !important;
}

.opBtn:hover {
  color: #e6a755;
}

.userAdd_man {
  min-height: 300px;
  overflow: auto;
  padding: 0 30px;
}

.userFrom {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
}

.el-form-item {
  margin-bottom: 0;
}
</style>
